import {
  ANDROID_APP_PACKAGE,
  resolveAppStoreOpenUrl,
} from '../config/app-links';
import {
  detectMobileStorePlatform,
  isAndroidDevice,
  type MobileStorePlatform,
} from '../config/device';
import { buildPaymentQrPayload, MERCHANT_PAYMENT_DEEP_LINK_PATH } from './render-qr';

/** Android intent URL — more reliable than raw `zippy://` in Chrome. */
export function buildAndroidPaymentIntentUrl(sessionId: string): string {
  return `intent://${MERCHANT_PAYMENT_DEEP_LINK_PATH}/${sessionId}#Intent;scheme=zippy;package=${ANDROID_APP_PACKAGE};end`;
}

/** Platform-aware deep link used when the customer taps Pay with Zippy / Try again. */
export function buildPaymentDeepLinkOpenUrl(
  sessionId: string,
  platform?: MobileStorePlatform,
): string {
  if (platform === 'android' || (platform == null && isAndroidDevice())) {
    return buildAndroidPaymentIntentUrl(sessionId);
  }

  return buildPaymentQrPayload(sessionId);
}

/** Sends the current tab to the App Store or Google Play for this device. */
export function openAppStore(platform?: MobileStorePlatform): void {
  if (typeof window === 'undefined') {
    return;
  }

  const resolved = platform ?? detectMobileStorePlatform();
  window.location.assign(resolveAppStoreOpenUrl(resolved));
}

/**
 * Opens the Zippy app from a user gesture (Pay with Zippy / Try again).
 * Keeps the checkout page visible so failed-handoff UI can appear afterward.
 */
export function openPaymentDeepLink(sessionId: string): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  openCustomSchemeWithoutNavigation(buildPaymentDeepLinkOpenUrl(sessionId));
}

function openCustomSchemeWithoutNavigation(url: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.style.display = 'none';
  link.setAttribute('aria-hidden', 'true');
  document.body.appendChild(link);
  link.click();
  link.remove();
}
